module.exports = __webpack_public_path__ + "img/guardian.94cafb79.jpg";